import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

const state = {
    promo_code: '', // initially '', updated when user inputs promo_code to Basket.vue AND clicks proceed to payment.vue
    coupon_id: '',  // initially '', to be implemented in future, when offer.vue is built (currently unused. 03/27/2025) -Noah
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}